import { EMPTY_OBJECT } from '../../../constants/common'

import { EXPORT_TABLE_FORM_FIELD_SELECT_ALL } from './TableExportModal.constants'

export function fillFormikValuesFromFieldList(fields, value) {
  return fields.reduce((acc, field) => {
    acc[field] = value

    return acc
  }, {})
}

export function getAdditionalParam() {
  return EMPTY_OBJECT
}

export function getSelectedParams(values) {
  return values
}

export function getSelectedFieldIdsFromOptions(values) {
  return Object.keys(values).filter(
    key => values[key] && key !== EXPORT_TABLE_FORM_FIELD_SELECT_ALL
  )
}
